import {
  useGetService,
  type UseGetServiceOptions,
} from "@libs/service-providers/api-service-provider";

import { VALIDATION_SUMMARY_URL } from "./apiEndpoints";
import type { ApiResponse, ValidationSummaryItem } from "./types";

type UseGetValidationSummaryOptions = Omit<
  UseGetServiceOptions<ApiResponse<ValidationSummaryItem[]>>,
  "route" | "queryKey"
>;

export const useGetValidationSummary = (options?: UseGetValidationSummaryOptions) =>
  useGetService<ApiResponse<ValidationSummaryItem[]>>({
    route: VALIDATION_SUMMARY_URL,
    queryKey: ["dq-dashboard", "validation-summary"],
    retry: false,
    ...(options ?? {}),
  });
